var styleDataHash = "51cdf0eb";
const injectCss = () => {
  var css = `._1xtsH,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.d0MMA{align-items:center;box-sizing:border-box;display:flex;flex-direction:row-reverse;font-family:inherit;height:50px;justify-content:space-between;position:absolute;top:0;width:100%;z-index:13}[dir] .d0MMA{background-color:#fff;border-bottom:1px solid #ededed;padding:0 16px}[dir=ltr] .d0MMA{left:0}[dir=rtl] .d0MMA{right:0}.d0MMA *,.d0MMA :after,.d0MMA :before{box-sizing:inherit}.d0MMA input{box-sizing:border-box}.d0MMA .DJtEk{align-self:center;color:#646464;font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:16px;font-weight:400}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var settings_mobile_header_default = {
  "fontElementMap": "_1xtsH",
  "setting_mobile_header": "d0MMA",
  "setting_mobile_header_title": "DJtEk"
};
export {
  settings_mobile_header_default as default,
  injectCss
};
//# sourceMappingURL=settings-mobile-header-scss.js.map
